// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.program-progress-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 10px;
}
.program-progress-container .program-progress-suggested {
  width: 80px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid #D3E1ED;
  background-color: #F5F9FF;
  font-size: 10px;
  font-weight: bold;
  color: #88ABB4;
  display: flex;
  align-items: center;
  justify-content: center;
}
.program-progress-container .program-progress-completed {
  width: 80px;
  height: 20px;
  border-radius: 4px;
  background-color: rgba(64, 160, 193, 0.168627451);
  font-size: 10px;
  font-weight: bold;
  color: #40A0C1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.program-progress-container .program-progress-label {
  font-size: 10px;
  color: #88ABB4;
}
.program-progress-container .program-progress-bar {
  position: relative;
  width: 80px;
  height: 6px;
  border-radius: 18px;
  background-color: #DBE7F1;
}
.program-progress-container .program-progress-bar .program-progress-bar-filled {
  position: absolute;
  height: 6px;
  border-radius: 18px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/Widgets/ProgramCategoryBox/ProgramProgress/ProgramProgress.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AACD;AACC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AAEC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iDAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;AAGC;EACC,eAAA;EACA,cAAA;AADF;AAIC;EACC,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;AAFF;AAIE;EACC,kBAAA;EACA,WAAA;EACA,mBAAA;AAFH","sourcesContent":[".program-progress-container {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tcolumn-gap: 10px;\n\n\t.program-progress-suggested {\n\t\twidth: 80px;\n\t\theight: 20px;\n\t\tborder-radius: 4px;\n\t\tborder: 1px solid #D3E1ED;\n\t\tbackground-color: #F5F9FF;\n\t\tfont-size: 10px;\n\t\tfont-weight: bold;\n\t\tcolor: #88ABB4;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n\n\t.program-progress-completed {\n\t\twidth: 80px;\n\t\theight: 20px;\n\t\tborder-radius: 4px;\n\t\tbackground-color: #40A0C12B;\n\t\tfont-size: 10px;\n\t\tfont-weight: bold;\n\t\tcolor: #40A0C1;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n\n\t.program-progress-label {\n\t\tfont-size: 10px;\n\t\tcolor: #88ABB4;\n\t}\n\n\t.program-progress-bar {\n\t\tposition: relative;\n\t\twidth: 80px;\n\t\theight: 6px;\n\t\tborder-radius: 18px;\n\t\tbackground-color: #DBE7F1;\n\n\t\t.program-progress-bar-filled {\n\t\t\tposition: absolute;\n\t\t\theight: 6px;\n\t\t\tborder-radius: 18px;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
